import { uiActions } from "./ui-slice";
import { cartActions } from "./cart-slice";

export const fetchCartData = (cart) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const respone = await fetch('https://first-project-9e0bc-default-rtdb.firebaseio.com/cart.json');

      if (!respone.ok) {
        throw new Error('could not fetch cart data!');
      }

      const data = await respone.json();
      return data;
    }

    try {
      const cartData = await fetchData();
      dispatch(cartActions.replaceCart({
        items: cartData ? cartData.items || [] : [],
        totalQuantity: cartData?.totalQuantity || (cartData?.items ? cartData.items.reduce((sum, item) => sum + item.quantity, 0) : 0),
      }));
    } catch (error) {
      dispatch(uiActions.showNotification({
        status: 'error',
        title: 'Error!',
        message: 'Fetching cart data failed!'
      }));
    }
  };
}

export const sendCartData = (cart) => {
  return async (dispatch) => {
    dispatch(uiActions.showNotification({
      status: 'pending',
      title: 'sending...',
      message: 'sending cart data!'
    }));

    const sendRequest = async () => {
      const response = await fetch('https://first-project-9e0bc-default-rtdb.firebaseio.com/cart.json', {
        method: "PUT",
        body: JSON.stringify({
          items: cart.items,
          totalQuantity: cart.totalQuantity,
        }),
      });

      if (!response.ok) {
        throw new Error('Sending cart data failed.');
      }
    }

    try {
      await sendRequest();

      dispatch(uiActions.showNotification({
        status: 'success',
        title: 'success!',
        message: 'sent cart data successfuly'
      }));
    } catch (error) {
      dispatch(uiActions.showNotification({
        status: 'error',
        title: 'Error!',
        message: 'Sending cart data failed!'
      }));
    }
  }
}